<template>
  <div class="grid grid-cols-3 gap-4">
    <div>
      <base-label>Start Date</base-label>
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="Select a date"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>

    <div>
      <base-label>End Date</base-label>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="Select a date"
        class="w-full"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>
    <div>
      <base-button-primary class="mt-5" @click="handleSearch"
        >Search</base-button-primary
      >
      <base-button-primary class="mt-5 ml-5" @click="handleExport"
        >Export</base-button-primary
      >
    </div>
    <div class="col-span-3 text-sm">
      <vue-good-table
        :columns="columns"
        :rows="orders"
        :search-options="{ enabled: true }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'id', type: 'asc' },
        }"
        :fixed-header="true"
        max-height="800px"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 50,
          position: 'bottom',
          perPageDropdown: [25, 50, 100],
          dropdownAllowAll: false,

          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'hash'">
            {{ props.row.hash ? "Success" : "Fail" }}
          </span>
          <span v-else-if="props.column.field == 'id'">
            <span
              class="cursor-pointer text-blue-600"
              @click="navigateToDetail(props.row)"
            >
              {{ props.row.id }}</span
            >
          </span>
          <span v-else-if="props.column.field == 'isExternal'">
            {{ props.row.isExternal ? "Yes" : "No" }}
          </span>
          <span v-else-if="props.column.field == 'isCounterCheckout'">
            {{ props.row.isCounterCheckout ? "Yes" : "No" }}
          </span>
          <span v-else-if="props.column.field == 'subtotal'">
            ${{
              (
                props.row.subtotal / 100 +
                props.row.discount_value / 100 +
                props.row.discount24 / 100
              ).toFixed(2)
            }}
          </span>
          <span v-else-if="props.column.field == 'name'">
            ${{ (props.row.subtotal / 100).toFixed(2) }}
          </span>
          <span v-else-if="props.column.field == 'discount'">
            {{ props.row.discount ? props.row.discount.name : "None" }}
          </span>
          <span v-else-if="props.column.field == 'discount_value'">
            ${{
              ((props.row.discount_value + props.row.discount24) / 100).toFixed(
                2
              )
            }}
          </span>
          <span v-else-if="props.column.field == 'tax'">
            ${{
              (
                (props.row.processingFee +
                  props.row.riverFee +
                  props.row.riverSectionFee +
                  props.row.tax) /
                100
              ).toFixed(2)
            }}
          </span>

          <span v-else-if="props.column.field == 'total'">
            ${{ (props.row.total / 100).toFixed(2) }}
          </span>
          <span v-else-if="props.column.field == 'country'">
            <base-button-white-extra-small
              title="View"
              class="mr-1 mt-1"
              @click="showDetail(props.row.id)"
            >
              <font-awesome-icon
                icon="eye"
                class="fa-fw nav-icon"
              ></font-awesome-icon>
            </base-button-white-extra-small>
            <base-button-primary-extra-small
              title="Change Email"
              class="mr-1 mt-1"
              @click="changeEmail(props.row)"
            >
              <font-awesome-icon
                icon="envelope"
                class="fa-fw nav-icon"
              ></font-awesome-icon>
            </base-button-primary-extra-small>
            <base-button-primary-extra-small
              title="Resend"
              class="mt-1"
              @click="resend(props.row)"
            >
              <font-awesome-icon
                icon="redo"
                class="fa-fw nav-icon"
              ></font-awesome-icon>
            </base-button-primary-extra-small>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>

    <change-order-email
      :showModal="showEmailModal"
      :emailData="emailData"
      @saved="handleSavedEmail"
      @close="showEmailModal = false"
    ></change-order-email>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";
import ChangeOrderEmail from "../../common/ChangeOrderEmail";
import BaseButtonWhiteExtraSmall from "../../ui/buttons/BaseButtonWhiteExtraSmall";
import BaseButtonPrimaryExtraSmall from "../../ui/buttons/BaseButtonPrimaryExtraSmall";
export default {
  name: "Full",
  components: {
    ChangeOrderEmail,
    BaseButtonPrimary,
    BaseButtonWhiteExtraSmall,
    BaseButtonPrimaryExtraSmall,
    VueGoodTable,
  },

  props: {},
  data() {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
          type: "number",
        },
        {
          label: "Date",
          field: "display_date",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Notes",
          field: "notes",
        },
        {
          label: "Coupon",
          field: "discount",
        },
        {
          label: "Base Price",
          field: "subtotal",
          type: "decimal",
        },
        {
          label: "Discount",
          field: "discount_value",
          type: "decimal",
        },
        {
          label: "Subtotal",
          field: "name",
          type: "decimal",
        },
        {
          label: "Taxes/Fees",
          field: "tax",
          type: "decimal",
        },
        {
          label: "Total",
          field: "total",
          type: "decimal",
        },
        {
          label: "Details",
          field: "country",
        },
      ],
      showEmailModal: false,
      emailData: {
        id: null,
        email: null,
      },
    };
  },
  methods: {
    navigateToDetail(row) {
      this.$router.push("/dashboard/order-detail/" + row.id);
    },
    handleSavedEmail() {
      this.handleSearch();
      this.emailData = {
        id: null,
        email: null,
      };
      this.showEmailModal = false;
    },
    resend(row) {
      if (confirm("Are you sure you want to re-email this order?")) {
        this.$notify({
          title: "Order",
          message: "Resending...",
          type: "success",
        });
        this.$store.dispatch("order/resend", row.id).then((resp) => {
          if (!resp.success) return;
          this.$notify({
            title: "Order",
            message: "This order has been resent",
            type: "success",
          });
        });
      }
    },
    changeEmail(row) {
      this.emailData.id = row.id;
      this.emailData.email = row.email;
      this.showEmailModal = true;
    },
    handleExport() {
      let url = process.env.VUE_APP_BASE_URL + "/order/export-orders";
      url += "?outfitterId=" + this.$store.getters["auth/outfitterId"];
      url += this.startDate ? "&startDate=" + this.startDate : "";
      url += this.endDate ? "&endDate=" + this.endDate : "";
      url = encodeURI(url);
      window.open(url, "_blank");
    },
    handleSearch() {
      this.$notify({
        title: "Order",
        message: "Fetching data...",
        type: "success",
      });
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        outfitterId: this.outfitterId,
      };
      this.$store.dispatch("order/get_orders", data).then((resp) => {
        if (!resp.orders || !resp.orders.length) {
          this.$notify({
            title: "Order",
            message: "No orders found for these dates",
            type: "warning",
          });
        }
      });
    },
    showDetail(id) {
      this.$router.push("/dashboard/order-detail/" + id);
    },
  },
  computed: {
    orders: function () {
      return this.$store.getters["order/getOrders"];
    },
    outfitterId: function () {
      return this.$store.getters["auth/outfitterId"];
    },
    startDate: {
      get() {
        return this.$store.getters["report/getStartDate"];
      },
      set(value) {
        this.$store.dispatch("report/set_start_date", value);
      },
    },
    endDate: {
      get() {
        return this.$store.getters["report/getEndDate"];
      },
      set(value) {
        this.$store.dispatch("report/set_end_date", value);
      },
    },
  },
  watch: {
    outfitterId: function () {
      this.handleSearch();
    },
  },
  mounted() {
    if (this.outfitterId) {
      this.handleSearch();
    }
  },
};
</script>

<style scoped>
>>> table.vgt-table td {
  padding: 0.25em;
  font-size: 14px;
}
>>> .vgt-table th.sortable button {
  font-size: 14px;
}
</style>
